module.exports = __webpack_public_path__ + "static/media/crdsciblock.293d548b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/crdsciblock.png
// module id = 289
// module chunks = 0